import orders from './columns/orders';
import jobs from './columns/jobs';
import titles from './columns/titles';
import tasks from './columns/tasks';
import processingTasks from './columns/processingTasks';
import pendingAssets from './columns/pendingAssets';
import theme from './theme';
import jobDetails from './jobDetails';
import dataConfig from './dataConfig';
import dashboardConfig from './dashboardConfig';
import taskConfig from './taskConfig';
import orderPlacementConfig from './orderPlacementConfig';
import { AllTableColumnsConfig, ClientConfig, OmakasePlayerFeature, TimecodeFormat } from '@tmt-insights/oms_fe_core';
import { DeepPartial } from '@/redux/slices/slice_types';
import fileIngest from './columns/fileIngest';
import titleConfig from './titleConfig';
import TitleHierarchy from '../components/TitleHierarchy';

const config: DeepPartial<ClientConfig> = {
  clientName: 'NatGeo',
  theme,
  columns: { orders, jobs, processingTasks, tasks, titles, pendingAssets, fileIngest } as DeepPartial<AllTableColumnsConfig<unknown>>,
  jobDetails,
  dataConfig,
  taskConfig,
  titleConfig,
  dashboardConfig,
  orderPlacementConfig,

  omakasePlayerConfig: {
    timecodeFormat: TimecodeFormat.Frames,
    features: [
      OmakasePlayerFeature.MEDIA_INFO,
      OmakasePlayerFeature.SUBTITLES,
      OmakasePlayerFeature.AUDIO_TRACKS,
      OmakasePlayerFeature.THUMBNAILS,
      OmakasePlayerFeature.QC_MARKERS,
      OmakasePlayerFeature.QC_FORM
    ],
    enableMultipleAudioTracks: true
  },

  ingestManagementConfig: {
    version: 'v2',
    asperaUploadInfo: true,
    chart: {
      colors: ['primary', 'secondary', 'default'],
      glow: {
        opacity: 0.1,
        color: 'tertiary'
      }
    }
  },
  userColors: ['#aa6600', '#118833', '#6e2a9f', '#952a9f', '#cc4455', '#71a400', '#667799', '#bb44aa', '#8855ee', '#5566ee', '#4466ff', '#dd2277'],
  versionColors: {
    // core: '#72A73C',
    // nlm: '#EC5743',
    // glb: '#B16BE9',
    // bcm: '#5566ee'
  },
  enableUserDocumentation: true,
  disableJobDetailProxy: false,
  versionSelectShowUnspecifiedVersion: true,
  commonConstants: {
    fileTypeGrouping: {
      video: ['mov', 'mxf', 'mp4', 'avi', 'mpg', 'mpeg'],
      audio: ['wav', 'aac', 'mp3'],
      subtitle: ['srt', 'scc', 'vtt', 'webvtt', 'sub', 'ass', 'ssa', 'ttml', 'dfxp', 'itt', 'stl'],
      captions: [],
      image: ['jpg', 'jpeg', 'bmp', 'png', 'gif', 'svg', 'tiff', 'tif'],
      other: ['pdf', 'prproj', 'xml', 'csv', 'xls', 'xlsx', 'txt', 'doc', 'docx']
    }
  },

  bulkActionIcons: {
    cancel_job: 'cancel',
    restart_job: 'refresh',
    retry_rally_job: 'reset'
  },
  titleHierarchyComponent: TitleHierarchy
};

export default config;
